import type { ServerColDef } from '@cmg/data-grid';

import { createModifiedOnColDef } from '../../components/shared-columns/modified-on/modified-on';
import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';
import accountEmailColDef from './account-email';
import accountNameColDef from './account-name';
import activeUserAccountColDef from './active-user-account';
import coveredAccountsColDef from './covered-accounts';
import emailColDef from './email';
import employeeKeyColDef from './employee-key';
import nameColDef from './name';
import statusColDef from './status';
import updatedByColDef from './updated-by';

export const salesCoverageColumnDefs: ServerColDef<UnderwriterEmployeeFragment>[] = [
  employeeKeyColDef,
  nameColDef,
  accountNameColDef,
  accountEmailColDef,
  emailColDef,
  statusColDef,
  coveredAccountsColDef,
  activeUserAccountColDef,
  createModifiedOnColDef<UnderwriterEmployeeFragment>('modifiedOn'),
  updatedByColDef,
];
